import { useMemo, useCallback } from 'react';
import { useOrderCSVImportContext } from '../../../components/order-import/order-import-context';
import { useOrderImportBasicFeatureGate } from '../../../feature-gates/use-order-import-basic-feature-gate';
import { useTrackWorkflow, WorkflowSteps } from '../../../tracking/use-workflow-tracking';
import { EventSourceStrings, Workflows } from '../../../tracking/tracking-constants';
import { useEnableNewOrderImport } from '../../../feature-flags/hooks/use-enable-new-order-import';
import { messages } from './messages';

export const useImportOrders = () => {
  const { openCSVImport } = useOrderCSVImportContext();
  const { isFeatureEnabled: hasOrderImportBasic } = useOrderImportBasicFeatureGate();
  const isNewOrderImportEnabled = useEnableNewOrderImport();
  const workflow = isNewOrderImportEnabled ? Workflows.CSV_ORDER_IMPORT_FLOW : Workflows.ORDER_IMPORT_FLOW;
  const trackOrderImport = useTrackWorkflow(workflow);
  const actionHandler = useCallback(() => {
    trackOrderImport(WorkflowSteps.START, {
      source: EventSourceStrings.ORDER_GRID_HEADER_OTHER_ACTIONS_DROPDOWN,
    });
    openCSVImport();
  }, [openCSVImport, trackOrderImport]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsImport,
      hideFromCurrentPlan: !hasOrderImportBasic,
      isDisabled: false,
      disabledReason: null,
    };
  }, [actionHandler, hasOrderImportBasic]);
};
